import React, { useState } from "react";
export const useForm = (
  initialForm,
  validateForm,
  stateValue,
  setStatebutton
) => {
  const [form, setForm] = useState(initialForm);
  const [errors, setErrors] = useState("");

  const handleChange = (e) => {
    if (e.title) {
      setForm({ ...form, payments: e });
    }

    if (e.target) {
      const { name, value } = e.target;
      if (name === "name" || name === "lastName" || name === "nameTarjeta") {

        const re = /^[a-zA-Z ]+$/;
        if (value === "" || re.test(value)) {
          if (value.length <= 40) {
            setForm({
              ...form,
              [name]: value,
            });
          }
        }
      }
      else if (name === "nameZelle" || name === "lastNameZelle" || name === "nameCredito") {
        if (value.length <= 40) {
          setForm({
            ...form,
            [name]: value,
          });
        }
      }
      else {
        if ((e.target.type !== "number" && name !== "cvc") && (e.target.type !== "number" && name !== "pinCard")
          && (e.target.type !== "number" && name !== "numberCardCredit")
          && (e.target.type !== "number" && name !== "cvvCard")
          && (e.target.type !== "number" && name !== "numberCard")
          && (e.target.type !== "number" && name !== "code")
          && (e.target.type !== "number" && name !== "numberCardCredicard")
          && (e.target.type !== "number" && name !== "cuentaBancaria")
          && (e.target.type !== "number" && name !== "ctaBancariaAll")) {
          setForm({
            ...form,
            [name]: value,
          });
        }
      }
      if (name === "monto" || name === "montoIVA" || name === "montoISLR" || name === "montoCompMunicipal" || name === "montoTimbreFiscal") {
        const re = /^[1-9]([0-9]{1,2})?([.][0-9]{2})?$/;
        if (value === "" || re.test(value)) {

          setForm({
            ...form,
            [name]: value,
          });
        }
      }
      if ((name === "cvc" && e.target.type === "text") || (name === "cvc" && e.target.type === "password")) {
        const re = /^[0-9\b]+$/;
        if (value === "" || re.test(value)) {
          if (value.length <= 4) {
            setForm({
              ...form,
              [name]: value,
            });
          }
        }
      }
      if ((name === "pinCard" && e.target.type === "text") || (name === "pinCard" && e.target.type === "password")) {
        const re = /^[0-9\b]+$/;
        if (value === "" || re.test(value)) {
          if (value.length <= 6) {
            setForm({
              ...form,
              [name]: value,
            });
          }
        }
      }
      if ((name === "numberCard" && e.target.type === "text") || (name === "numberCard" && e.target.type === "password")) {
        const re = /^[0-9\b]+$/;
        if (value === "" || re.test(value)) {
          if (value.length <= 18) {
            setForm({
              ...form,
              [name]: value,
            });
          }
        }
      }

      if ((name === "numberCardCredit" && e.target.type === "text") || (name === "numberCardCredit" && e.target.type === "password")) {
        const re = /^[0-9\b]+$/;
        if (value === "" || re.test(value)) {
          if (value.length <= 16) {
            setForm({
              ...form,
              [name]: value,
            });
          }
        }
      }
      if ((name === "numberCardCredicard" && e.target.type === "text") || (name === "numberCardCredicard" && e.target.type === "password")) {
        const re = /^[0-9\b]+$/;
        if (value === "" || re.test(value)) {
          if (value.length <= 19) {
            setForm({
              ...form,
              [name]: value,
            });
          }
        }
      }

      

      if ((name === "otp" && e.target.type === "text") || (name === "otp" && e.target.type === "password")) {
        const re = /^[0-9\b]+$/;
        if (value === "" || re.test(value)) {
          if (value.length <= 8) {
            setForm({
              ...form,
              [name]: value,
            });
          }
        }
      }

      if ((name === "cvvCard" && e.target.type === "text") || (name === "cvvCard" && e.target.type === "password")
        || (name === "code" && e.target.type === "text") || (name === "code" && e.target.type === "password")) {
        const re = /^[0-9\b]+$/;
        if (value === "" || re.test(value)) {
          if (value.length <= 3) {
            setForm({
              ...form,
              [name]: value,
            });
          }
        }
      }

      if (name === "typeDoc" && e.target.type === "text") {
        const re = /^[A-Za-z0-9]+$/;
        if (value === "" || re.test(value)) {
          if (value.length <= 13) {
            setForm({
              ...form,
              [name]: value,
            });
          }
        }
      }
      if (name === "cuentaBancaria" && e.target.type === "text") {
        const re = /^[0-9\b]+$/;
        if (value === "" || re.test(value)) {
          if (value.length <= 16) {
            setForm({
              ...form,
              [name]: value,
            });
          }
        }
      }


      if (name === "ctaBancariaAll" && e.target.type === "text") {
        const re = /^[0-9\b]+$/;
        if (value === "" || re.test(value)) {
          if (value.length <= 20) {
            setForm({
              ...form,
              [name]: value,
            });
          }
        }
      }
      /*else if (name === "typeDoc" && e.target.type === "number") {
        const re = /^[0-9\b]+$/;
        if (value === "" || re.test(value)) {
          if (value.length <= 13) {
            setForm({
              ...form,
              [name]: value,
            });
          }
        }
      }*/

      if (e.target.type === "number") {
        switch (name) {

          case "phone":
            if (value.length <= 7) {
              setForm({
                ...form,
                [name]: value,
              });
            }
            break;
          case "dateExpirationDay":
            if (value.length <= 2) {
              setForm({
                ...form,
                [name]: value,
              });
            }
            break;
          case "dateExpirationMonth":
            if (value.length <= 4) {
              setForm({
                ...form,
                [name]: value,
              });
            }
            break;
          case "month":
            if (value.length <= 2) {
              setForm({
                ...form,
                [name]: value,
              });
            }
            break;
          case "year":
            if (value.length <= 4) {
              setForm({
                ...form,
                [name]: value,
              });
            }
            break;
          case "token":
            if (value.length <= 8) {
              setForm({
                ...form,
                [name]: value,
              });
            }
            break;
          case "keyCode":
            if (value.length <= 4) {
              setForm({
                ...form,
                [name]: value,
              });
            }
            break;
          case "numberReference":
            if (value.length <= 12) {
              setForm({
                ...form,
                [name]: value,
              });
            }
            break;
          case "typeDoc":
            if (value.length <= 13) {
              setForm({
                ...form,
                [name]: value,
              });
            }
            break;
          case "typeDocCredicard":
            if (value.length <= 9) {
              setForm({
                ...form,
                [name]: value,
              });
            }
            break;

          default:
            setForm({
              ...form,
              [name]: value,
            });
            break;
        }
      }
    }
  };
  const handleBlur = (e) => {

    handleChange(e);
    const currentErrors = validateForm(form, stateValue, setStatebutton) || {};
    setErrors(currentErrors);
  };
  const handleSubmit = () => {

    const currentErrors = validateForm(form, stateValue, setStatebutton) || {};
    setErrors(currentErrors);
    if (Object.keys(currentErrors).length === 0) {
      return "ok";
    }
  };

  return {
    form,
    errors,
    setForm,
    setErrors,
    handleChange,
    handleSubmit,
    handleBlur,
  };
};
